import React from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";
import Button from "../../../..//Elements/Button/Button.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useToasts } from "react-toast-notifications";
import parse from "html-react-parser";
import config from "config";
import ToastHtmlComponent from "../../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";

const DeleteForm = ({
  formId,
  emailsCount,
  setDynamicFormsList,
  setLoadingFormId,
  setIsUpdateFormList,
}) => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  const { addToast } = useToasts();

  //delete form
  const DeleteForm = async (removeFormMails) => {
    setLoadingFormId((prev) => [...prev, formId]);
    closeModal();
    const requestBody = {
      EmbedDynamicId: formId,
      RemoveMails: removeFormMails,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "DeleteFormReact",
      requestBody,
      "POST"
    );
    if (response.status === "success") {
      if (response.data === 0) {
        setDynamicFormsList((prev) =>
          prev.filter((item) => item.Embed_Dynamic_Id !== formId)
        );
        setIsUpdateFormList(true);
        if (removeFormMails) {
          addToast(getTextByKey("delete-form-emails-done"), {
            appearance: "success",
          });
        } else {
          addToast(getTextByKey("delete-form-done"), {
            appearance: "success",
          });
        }
      }
    } else {
      let errText = getTextByKey("api-error");
      errText = errText.replace("#ERRORNUM#", response.data);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      errText = errText.replace("#SYSMAIL#", config.supportmail);
      errText = errText.replace("#SYSMAIL#", "contact-us");
      addToast(<ToastHtmlComponent htmlStr={errText} />, {
        appearance: "error",
      });
    }

    setLoadingFormId((prev) => prev.filter((id) => id !== formId));
  };

  //replace constText
  const convertDeleteFormMailsText = (text) => {
    text = text.replaceAll("#MailsCount#", emailsCount);
    return text;
  };

  return (
    <div className="delete-form-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            {emailsCount > 0 ? (
              <p>
                {parse(
                  convertDeleteFormMailsText(
                    getTextByKey("jumboforms-delete-form-emails-text")
                  )
                )}
              </p>
            ) : (
              <p>{getTextByKey("jumboforms-delete-form-question")}</p>
            )}
            <div className="actions">
              {emailsCount > 0 ? (
                <Button
                  buttonClass="delete-form-button"
                  onClick={() => {
                    DeleteForm(true);
                  }}
                >
                  {getTextByKey("jumboforms-delete-form-emails-button")}
                </Button>
              ) : null}
              <Button
                blank
                buttonClass="delete-form-button"
                onClick={() => {
                  DeleteForm(false);
                }}
              >
                {getTextByKey("jumboforms-delete-form")}
              </Button>
              <Button
                blank
                buttonClass="delete-form-button blank"
                onClick={() => {
                  closeModal();
                }}
              >
                {getTextByKey("jumboforms-delete-form-cancel")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default DeleteForm;
